import React from 'react';
import {useSelector, shallowEqual} from 'react-redux';
import {Chatbot} from '../../states/actions';
import {IntNodeComponent, InputComponent, SelectComp} from './Components';
import {createSelectNodeData} from '../../states/selectors/chatbotSelectors';

export const MatchV2Block = React.memo((node) => {
  const {block, start, progress} = useSelector(createSelectNodeData(node.id), shallowEqual);
  const bot = {progress: progress || []};

  if (!block) {
    return null;
  }
  const {data} = block;

  return (
    <IntNodeComponent bot={bot} name="Match v2" icon="match" data={data} node={node} start={start} />
  );
});

export const MatchV2Editor = ({block}) => {
  const {data} = block;

  if (!block) {
    return null;
  }

  const variableoptions = Chatbot.getBlockVariables();

  const handleBlur = (e) => {
    Chatbot.setBlockData(block.id, {[e.target.name]: e.target.value});
  };

  return (
    <>
      <div className="section">Match v2</div>
      <SelectComp
        data={data}
        name="Client text variable"
        dataname="textvariable"
        placeholder="Select"
        options={variableoptions}
        block={block}
        value="label"
      />
      <InputComponent
        data={data}
        name="Params profile"
        dataname="paramsprofile"
        placeholder="default"
        onBlur={handleBlur}
      />
      <InputComponent
        data={data}
        name="Data prefix"
        dataname="variableprefix"
        placeholder="mv2"
        onBlur={handleBlur}
      />
      <SelectComp
        data={data}
        name="Service variable"
        dataname="service"
        placeholder="Select"
        options={variableoptions}
        block={block}
        value="label"
      />
      <SelectComp
        data={data}
        name="Client type"
        dataname="clientTypeMode"
        placeholder="auto"
        options={[
          {label: 'Auto (flow / chat / classifier)', value: 'auto'},
          {label: 'Person', value: 'person'},
          {label: 'Business', value: 'business'},
        ]}
        block={block}
        value="value"
      />
      <SelectComp
        data={data}
        name="Client type variable"
        dataname="clienttypevariable"
        placeholder="Select"
        options={variableoptions}
        block={block}
        value="label"
      />
    </>
  );
};
